module.exports = __webpack_public_path__ + "img/20191108155223360截图20191108150137190.a4ffc7ad.jpg";